(() => {
  // Reviews carousel: native scroll-snap does the swiping; arrows/dots are added only when the track overflows
  document.querySelectorAll('[data-ps-reviews]').forEach((section) => {
    const track = section.querySelector('[data-ps-reviews-track]');
    const controls = section.querySelector('[data-ps-reviews-controls]');
    if (!track || !controls) return;
    const prev = controls.querySelector('[data-ps-reviews-prev]');
    const next = controls.querySelector('[data-ps-reviews-next]');
    const dotsWrap = controls.querySelector('[data-ps-reviews-dots]');
    const cards = [...track.children];

    const step = () => {
      if (cards.length < 2) return track.clientWidth;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    };
    const pages = () => {
      const visible = Math.max(1, Math.round(track.clientWidth / step()));
      return Math.max(1, cards.length - visible + 1);
    };
    const current = () => Math.round(track.scrollLeft / step());

    const buildDots = () => {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (let i = 0; i < pages(); i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ps-hp-reviews__dot';
        dot.setAttribute('aria-label', `Go to review ${i + 1}`);
        dot.addEventListener('click', () => track.scrollTo({ left: i * step(), behavior: 'smooth' }));
        dotsWrap.appendChild(dot);
      }
    };

    const update = () => {
      const i = current();
      dotsWrap?.querySelectorAll('.ps-hp-reviews__dot').forEach((d, n) => d.setAttribute('aria-current', String(n === i)));
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };

    const refresh = () => {
      // Grid layout or everything fits → no controls
      const overflowing = track.scrollWidth > track.clientWidth + 2;
      controls.hidden = !overflowing;
      if (!overflowing) return;
      buildDots();
      update();
    };

    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', refresh, { passive: true });
    refresh();
  });
})();
